import { render, staticRenderFns } from "./TextNoteLink.vue?vue&type=template&id=3556ea04&"
import script from "./TextNoteLink.vue?vue&type=script&lang=js&"
export * from "./TextNoteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports